import React, { useState, useEffect } from 'react';
import RegistrationForm from '../components/RegistrationForm';
import {useParams} from "react-router-dom";
import {getDistances, getSwimmers, registerSwimmer} from "../api";


const SuccessPage = () => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [swimmerData, setSwimmerData] = useState(null);

   // console.log(params);
    const prodId = params.id;


    useEffect(() => {
            const loadRegs = async () => {
                try {
                    setLoading(true)
                    //const response = await getDistances(formData.gender);
                    const response = await getSwimmers(prodId);
                    setSwimmerData(response.data);
                    //console.log(swimmerData);
                } catch (error) {
                    console.error('Error loading distances:', error);
                } finally {
                setLoading(false);
                }
            };
            loadRegs();
    }, []);

    if (!swimmerData) {
        return (
            <div className="registration-container">
                <div className="text-center py-10">
                    <p className="text-gray-500">Данные о регистрациях не найдены</p>
                </div>
            </div>
        );
    }
    else {
        console.log(swimmerData);
    }

    return (

        <div className="registration-container">
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                {/* Заголовок */}
                <div className="px-4 py-5 sm:px-6 bg-gray-50">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                        Вы зарегистрированы
                    </h3>

                </div>

                {/* Информация о пловце */}
                <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                    <dl className="sm:divide-y sm:divide-gray-200">
                        <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Номер регистрации: <b>{swimmerData.swimmer.id}</b></dt>
                        </div>
                        <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Фамилия и имя: {swimmerData.swimmer.full_name}</dt>
                        </div>
                        <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Дата рождения: {new Date(swimmerData.swimmer.birth_date).toLocaleDateString()}</dt>
                        </div>
                        <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Клуб: {swimmerData.swimmer.club
                                ? swimmerData.swimmer.club
                                : 'Лично'}</dt>

                        </div>

                        <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Общая сумма: <b>{swimmerData.swimmer.total_amount} руб.</b></dt>
                            {swimmerData.swimmer.total_amount_descr}
                        </div>
                    </dl>
                </div>
            </div>

            {/* Список дистанций */}
            <div className="mt-8 bg-white shadow overflow-hidden sm:rounded-lg">
                <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                        Зарегистрированные дистанции
                    </h3>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Дистанция
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Стиль
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Заявочное время
                            </th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {swimmerData.registrations.map((reg) => (
                            <tr key={reg.distance_id}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    {reg.meters} метров
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {reg.style}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {reg.entry_time || 'Не указано'}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {swimmerData.swimmer.total_amount > 0 &&
            <div className="mt-8 bg-white shadow overflow-hidden sm:rounded-lg">
                <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                        Данные для оплаты
                    </h3>
                </div>
                <div className="overflow-x-auto bigtext">
                    Для упрощённой оплаты без комиссии за участие в соревнованиях можно пройти по следующему алгоритму:
                    <p>1. Заходите в любой свой банк. Находите там - оплата по реквизитам.</p>
                    <p>2. Пишите номер счёта - <b>42301810500084480512</b></p>
                    <p>3. Выбирайте Т-Банк</p>
                    <p>4. Пишите ФИО - <b>Есин Михаил Александрович</b></p>
                    <p>5. Назначение платежа - <b>№{swimmerData.swimmer.id} {swimmerData.swimmer.full_name}</b>.</p>
                    <p>6. Пишите сколько нужно перевести денег и отправляете . За перевод комиссия не взимается.</p>
                </div>
            </div>}
            {/* Кнопка возврата */}

            {/*{swimmerData.swimmer.total_amount > 0 && <div className="mt-8 text-center">*/}
            {/*    <a href={'https://www.tbank.ru/cf/1o4XyhYDvvs'} className={'submit-button'} target={'_blank'}>Оплатить</a>*/}
            {/*</div>}*/}
        </div>
    );
};


export default SuccessPage;
